import React from 'react'
import parse from 'html-react-parser'

const WYSIWYGBlock = ({ wysiwygBlock }) => {
    const { wysiwyg, background } = wysiwygBlock || {}
    
    const backgroundStyles = (background) => {
        if (!background) return {background :'transparent'}

        if (background?.solidColor) {
            return { backgroundColor: background?.solidColor }
        }

        if (
            background?.gradientColor?.firstColor &&
            background?.gradientColor?.secondColor
        ) {
            return {
                background: `transparent linear-gradient(100deg, ${background?.gradientColor?.firstColor} 0%, ${background?.gradientColor?.secondColor} 100%) 0% 0% no-repeat padding-box`
            }
        }
    }
    return (
        <div className="py-10 relative">
            <div
                className="top-0 bottom-0 w-screen left-1/2 -translate-x-1/2 absolute -z-[1]"
                style={backgroundStyles(background)}
            ></div>
            <div className="container basic-rich-text">
                <div style={{color:backgroundStyles(background) ? '#fff':'#2b0838'}}>{wysiwyg && parse(wysiwyg)}</div>
            </div>
        </div>
    )
}

export default WYSIWYGBlock
